import React, { useState } from "react";

const EPrescription = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <div className="tab-panel" data-panel={10}>
        <div className="section-title_user">
          <span>E-Prescription</span>
          <button
            className="add-button_user"
            onClick={() => setIsModalOpen(true)}
          >
            Add / Edit
          </button>
        </div>
        <p style={{ textAlign: "left" }}>
          Set e-prescription options and pharmacy connections.
        </p>
      </div>
      <div className={`modal_setting ${isModalOpen ? "active" : ""}`}>
        <div className="modal-content_setting">
          <span
            className="close_setting"
            onClick={() => setIsModalOpen(false)}
            style={{ cursor: "pointer" }}
          >
            ×
          </span>
          <h2>Labs Integration</h2>
          <form>
            <div className="form-row_setting">
              <input type="text" placeholder="Enter details" required />
            </div>
            <div className="form-row_setting">
              <input type="text" placeholder="Additional info" required />
            </div>
            <button
              type="submit"
              className="add-button_user"
              style={{ alignSelf: "left", marginTop: 10, display: "flex" }}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default EPrescription;
